import Vue from 'vue';
import Router from 'vue-router';
import _ from 'lodash';
import PendingModule from '../components/shared/PendingModule.vue';
import api from './../api/activityLog.js';

Vue.use(Router);

const routerOptions = [
  {
    path: '/',
    redirect: '/home',
    visible: false
  },
  {
    path: '/routes',
    name: 'routes',
    visible: true,
    meta: { title: 'Catálogo de rutas', permissions: ['get-routes'] }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    visible: false,
    component: PendingModule,
    meta: {
      title: 'Dashboard',
      pendingReason: 'El panel anterior solo contiene un marcador de posición y aún no tiene indicadores conectados.',
      permissions: [
        'get-dashboard'
      ],
    }
  },
  {
    path: '/home',
    name: 'home',
    visible: false,
    meta: {
      title: 'Inicio'
    }
  },
  {
    path: '/login',
    name: 'login',
    visible: false,
  },
  {
    path: '/logout',
    name: 'logout',
    visible: false,
  },
  {
    path: '/users',
    name: 'users',
    visible: true,
    meta: {
      title: 'Usuarios / Gestión de Usuarios',
      permissions: ['get-users', 'authorization'],
    },
  },
  {
    path: '/reports/detail-report',
    name: 'reports/detail-report',
    visible: true,
    component: PendingModule,
    meta: {
      title: 'Reportes / Reporte Detallado',
      pendingReason: 'Este reporte depende de una base de datos adicional que todavía no está configurada en este entorno.',
      permissions: ['get-report-binnacle'],
    },
  },
  {
    path: '/catalogs/unities',
    name: 'catalogs/unities',
    visible: true,
    component: PendingModule,
    meta: {
      title: 'Catalogos / Unidades',
      pendingReason: 'La pantalla de unidades aún no tiene listado ni formulario operativo.',
      permissions: ['get-unities']
    }
  }
]
// Rutas
const routes = _.map(routerOptions, r => {
  return {
    ...r,
    component: r.component || (r.name ? () => import(`../components/${r.name}/index-component.vue`) : undefined)
  }
})

const router = new Router({
  mode: 'history',
  base: '/',
  routes
})

router.beforeEach((to, from, next) => {
  const pathModule = (_.split(to.meta.title, '/'))
  const module = pathModule[0];
  const subModule = pathModule[1];
  (to.name != 'login') ? api.storeActivityLog(
    {
      action: 'View',
      entity: 'User',
      module: module,
      sub_module: !_.isUndefined(subModule) ? subModule : module
    }
  ) : null;
  next()
})

export default router
